const authContextOptions = {
    baseUrl: process.env.REACT_APP_FRONTEGG_BASE_URL as string,
    clientId: process.env.REACT_APP_FRONTEGG_CLIENT_ID,
};

export default authContextOptions;
